import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { useLocation } from 'react-router-dom';

const APP_ROOTS = ['/', '/admin'];

export function BackButtonManager() {
  const location = useLocation();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    let handler: { remove: () => void } | undefined;

    App.addListener('backButton', () => {
      const isRoot = APP_ROOTS.includes(location.pathname);
      if (isRoot || window.history.length <= 1) {
        App.minimizeApp();
      } else {
        window.history.back();
      }
    }).then((h) => {
      handler = h;
    });

    return () => {
      handler?.remove();
    };
  }, [location.pathname]);

  return null;
}